
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { TreeNode, NodeType } from '@/modules/nomenclature/models/treeNode';

@Component({
  components: {}
})
export default class ProjectForm extends Vue {
  @Prop({ required: true })
  protected value!: TreeNode;
  @Prop({ required: true })
  protected saveCallBack!: (nodeEntity: TreeNode) => Promise<void>;
  protected sendingRequest = false;
  protected requestError = false;
  protected input?: TreeNode;

  protected created(): void {
    this.presetInput(this.value);
  }

  protected validate(): void {
    const isValid = (this.$refs.form as HTMLFormElement).validate();
    if (isValid) {
      this.sendingRequest = true;
      setTimeout(() => {
        if (this.input) {
          this.saveCallBack(this.input)
            .then(() => {
              (this.$refs.form as HTMLFormElement).resetValidation();
              this.presetInput(this.value);
              this.$emit('cancel');
            })
            .catch(() => (this.requestError = true))
            .finally(() => (this.sendingRequest = false));
        }
      }, 500);
    }
  }

  protected get radioTypes(): string[] {
    return [NodeType.PROJECT, NodeType.BUDGET_LINE];
  }

  @Watch('value', { immediate: true })
  protected presetInput(value: TreeNode): void {
    if (value.nodeType === NodeType.VIRTUAL) {
      this.input = {
        id: undefined,
        name: '',
        parentId: value.parentId,
        nodeType: NodeType.PROJECT
      };
    } else {
      this.input = {
        id: value.id,
        name: value.name,
        parentId: value.parentId,
        nodeType: value.nodeType
      };
    }
  }

  protected get NodeType(): Record<string, string> {
    return NodeType;
  }
}
